import React from 'react'
import PropTypes from 'prop-types'
import { Info as InfoIcon } from 'react-feather'
import { Box, Tab, Tabs, Tooltip } from '@material-ui/core'

import constants from 'constants/index'

const {
  ACCEPTED_DOCUMENTS_CATEGORY_ID,
  APPROVAL_DOCUMENTS_CATEGORY_ID,
  DOCUMENTS_CATEGORY_ID,
  HISTORY_DOCUMENTS_CATEGORY_ID,
  SETTINGS_DOCUMENTS_CATEGORY_ID,
  CONTROLS_DOCUMENTS_CATEGORY_ID,
} = constants.documents

const DocumentTabs = ({
  currentTab,
  onChange,
  disabledAcceptedTab = false,
  disabledAcceptedTooltip = '',
  showAcceptedTab = false,
  showApprovalTab = false,
  showControlsTab = false,
  showHistoryTab = false,
  showSettingsTab = false,
  disabledApprovalTab = false,
}) => {
  const TabLabel = ({ label, disabled, tooltip }) => (
    <Box display="flex" alignItems="center">
      {label}
      {disabled && tooltip && (
        <Box
          ml={1}
          display="flex"
          alignItems="center"
          style={{
            cursor: 'pointer',
            pointerEvents: 'all',
          }}
        >
          <Tooltip
            title={tooltip}
            placement="right"
            disableHoverListener={false}
            disableTouchListener={false}
            disableFocusListener={false}
          >
            <InfoIcon size={18} />
          </Tooltip>
        </Box>
      )}
    </Box>
  )

  return (
    <Box display="flex" alignItems="center">
      <Tabs
        scrollButtons="auto"
        value={currentTab}
        variant="scrollable"
        textColor="primary"
        indicatorColor="primary"
        onChange={onChange}
      >
        <Tab value={DOCUMENTS_CATEGORY_ID} label="Conteúdo" />
        {showSettingsTab && (
          <Tab value={SETTINGS_DOCUMENTS_CATEGORY_ID} label="Configurações" />
        )}
        {showApprovalTab && (
          <Tab
            value={APPROVAL_DOCUMENTS_CATEGORY_ID}
            label={
              <TabLabel
                label="Aprovação"
                disabled={disabledApprovalTab}
                tooltip="Você não pode modificar as aprovações se não estiver habilitado!"
              />
            }
            disabled={disabledApprovalTab}
          />
        )}
        {showAcceptedTab && (
          <Tab
            value={ACCEPTED_DOCUMENTS_CATEGORY_ID}
            label={
              <TabLabel
                label="Aceites"
                disabled={disabledAcceptedTab}
                tooltip={disabledAcceptedTooltip}
              />
            }
            disabled={disabledAcceptedTab}
          />
        )}
        {showControlsTab && (
          <Tab
            value={CONTROLS_DOCUMENTS_CATEGORY_ID}
            label={<TabLabel label="Controles" />}
          />
        )}
        {showHistoryTab && (
          <Tab value={HISTORY_DOCUMENTS_CATEGORY_ID} label="Histórico" />
        )}
      </Tabs>
    </Box>
  )
}

DocumentTabs.propTypes = {
  currentTab: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  disabledAcceptedTab: PropTypes.bool,
  disabledAcceptedTooltip: PropTypes.string,
  showAcceptedTab: PropTypes.bool,
  showApprovalTab: PropTypes.bool,
  showControlsTab: PropTypes.bool,
  showHistoryTab: PropTypes.bool,
  showSettingsTab: PropTypes.bool,
  disabledApprovalTab: PropTypes.bool,
}

export default DocumentTabs
